<template>
  <div class="banner">
    <!--<div id="carousel-example-generic" class="carousel slide" data-ride="carousel">-->
      <!--&lt;!&ndash; Indicators &ndash;&gt;-->
      <!--<ol class="carousel-indicators">-->
        <!--<li data-target="#carousel-example-generic" v-for='(banner,index) in bannerInfo' :key="index" :class="index == 0? 'active' : ''" :data-slide-to="index"></li>-->
      <!--</ol>-->
      <!--&lt;!&ndash; Wrapper for slides &ndash;&gt;-->
      <!--<div class="carousel-inner" role="listbox">-->
          <!--<div  v-for='(banner,index) in bannerInfo' :key="index" :class="index == 0? 'item active' : 'item'" >-->
              <!--<img  :src='banner.bannerPicturePath' @click='jump(banner.bannerPictureJumpLink)' alt="一链网"/>-->
            <!--<div class="carousel-caption">-->
            <!--</div>-->
          <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    <el-carousel :interval="ratationTime" arrow="never" id="el-carousel" @change="activeNumFn" ref="carousel" :autoplay="autoScroll">
      <el-carousel-item v-for="(banner,index) in bannerInfo" :key="index" name="index">
        <img :class="'imgHeight'+index" :src='banner.bannerPicturePath' @click='jump(banner.bannerPictureJumpLink, banner, index)' alt="一链网"/>
      </el-carousel-item>
    </el-carousel>
  
    <!--<div class="swiper-container">-->
      <!--<div class="swiper-wrapper">-->
        <!--<div class="swiper-slide">slider1</div>-->
        <!--<div class="swiper-slide">slider2</div>-->
        <!--<div class="swiper-slide">slider3</div>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>
<script>
  import {customOperationClick} from '@/assets/js/sensors'
export default {
  props: ['bannerInfo','ratationTime','loading'],
  data () {
    return {
      activeNum:0,
      bannerHeight:640,
      autoScroll:true
    }
  },
  mounted () {
//     this.bannerTime();
    this.bannerScroll();
    this.setHeight();
  },
  created(){
  },
  methods: {
    jump(url, item, index){
      // 埋点
      try {
        customOperationClick({
          page_title: "门户首页",
          operation_type: `门户轮播图`,
          operation_content: '广告图片',
          operation_name: `门户轮播-${ index + 1 }`,
          operation_id: item.bannerPictureInfoId
        })
      } catch (e) {
        console.log(e)
      }
     if(url.indexOf('http') == 0){
        window.location.href = url;
      }else{
        this.$router.push({path:url});
      }
    },
    bannerTime () {
//      var mySwiper = new Swiper('.swiper-container', {
//        autoplay: true,//可选选项，自动滑动
//      })
      // $('.carousel').carousel({
      //   interval: this.ratationTime
      // })
    },
    //    移动端手动滑动
    bannerScroll(){
      let $carousels = $('.el-carousel').eq(0);
      let start,   // 初始值
        end;    // 结束值
      $carousels.on('touchstart', function (e) {
        this.autoScroll = false;
        start = e.originalEvent.touches[0].clientX;// 触摸开始时记录一下手指所在的坐标x
      });
      $carousels.on('touchmove', function (e) {
        this.autoScroll = false;
        end = e.originalEvent.touches[0].clientX;// 离开屏幕一瞬间的坐标x
      });
      $carousels.on('touchend',  (e) => {
        let distance = Math.abs(start - end); // 获取差值
        if (distance > 30) {    //当差值大于30说明有方向的变化
          if(this.activeNum == 0){
            start > end ? this.$refs.carousel.setActiveItem(1) : this.$refs.carousel.setActiveItem(this.bannerInfo.length-1)
          }else{
            start > end ? this.$refs.carousel.setActiveItem(this.activeNum+1) : this.$refs.carousel.setActiveItem(this.activeNum-1)
          }
//          this.$refs.carousel.setActiveItem(0)//根据初始值和结束值的比较判断向前滑还是向后滑
        }
        this.autoScroll = true;
      })
    },
//    激活的幻灯片的索引
    activeNumFn(val){
      this.activeNum = val;
    },
    //    设置banner高度
    setHeight(){
      if($(document).width()>768){
        if($(document).width()<=1366){
          document.getElementById('el-carousel').style.height = 455 + 'px';
        }else{
          document.getElementById('el-carousel').style.height = this.bannerHeight + 'px';
        }
      }else{
        document.getElementById('el-carousel').style.height = 212 + 'px';
      }
    
      window.onresize=function () {
        // console.log(2)
        // console.log($('.imgHeight0').height())
        this.bannerHeight=$('.imgHeight0').eq(0).height()
        // console.log(this.bannerHeight+'px')
        document.getElementById('el-carousel').style.height = this.bannerHeight + 'px';
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/banner/index.vue